import { render, staticRenderFns } from "./supperUpload.vue?vue&type=template&id=1b2de51e&scoped=true"
import script from "./supperUpload.vue?vue&type=script&lang=js"
export * from "./supperUpload.vue?vue&type=script&lang=js"
import style0 from "./supperUpload.vue?vue&type=style&index=0&id=1b2de51e&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2de51e",
  null
  
)

export default component.exports